export default function FormatTime(seconds, isNeedHours = true) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;

  if (isNeedHours) {
    return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
  } else {
    if (h > 0) {
      return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
    }
    return [m, s].map((v) => String(v).padStart(2, "0")).join(":");
  }
}
